import { ajax } from '../../../services/helper'
class ApiService {

    getCategoriesData = (city_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/categories/list?city_id="+city_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getCategoryById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/categories/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getCategoryGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/categories/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    


    addCategory = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/categories/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editCategory = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/categories/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Categories/services/apiservices.js